import { Button } from "primereact/button";

const iconeAtendente = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    {/* cabeça */}
    <circle cx="12" cy="10" r="5.1" />
    {/* franja do cabelo */}
    <path d="M7.2 9.2c3.2.4 6-.8 7.2-3.4" />
    {/* faixa do headset */}
    <path d="M5.7 8.6a6.5 6.5 0 0 1 12.6 0" />
    {/* fones laterais */}
    <rect x="4.5" y="8.2" width="2.2" height="4.4" rx="1.1" />
    <rect x="17.3" y="8.2" width="2.2" height="4.4" rx="1.1" />
    {/* haste e microfone */}
    <path d="M6.7 12.6c.6 1.9 2.2 3 4.1 3.1" />
    <rect x="10.8" y="14.9" width="2.7" height="1.7" rx="0.85" />
    {/* ombros */}
    <path d="M8.9 14.5c0 1.5-.7 2.4-2.3 3-2.4.9-3.6 2.2-3.6 4.3" />
    <path d="M15.1 14.5c0 1.5.7 2.4 2.3 3 2.4.9 3.6 2.2 3.6 4.3" />
    <path d="M9.7 19.6v2.2" />
    <path d="M14.3 19.6v2.2" />
  </svg>
);

const TopbarSuporte = () => {
  return (
    <div>
      <Button
        className="button_relatorio"
        icon={iconeAtendente}
        rounded
        text
        style={{ color: 'white' }}
        tooltip="Suporte por WhatsApp"
        tooltipOptions={{ position: 'bottom' }}
        onClick={() => window.open('https://api.whatsapp.com/send?phone=+5511947302388&text=Olá preciso de atendimento', '_blank')}
      ></Button>
    </div>
  );
};

export default TopbarSuporte;
